import { reactive, ref, computed } from '@vue/composition-api';
import dayjs from 'dayjs';

// eslint-disable-next-line import/prefer-default-export
export function useFilterSchema(schema, initialValues = {}, message = '') {
  const filterSchema = ref([...schema]);
  const form = reactive(
    filterSchema.value.reduce((acc, item) => {
      acc[item.key] = typeof initialValues[item.key] !== 'undefined' ? initialValues[item.key] : '';
      return acc;
    }, {})
  );

  const rules = filterSchema.value.reduce((acc, item) => {
    if (item.rules) {
      acc[item.key] = item.rules;
    } else if (item.required) {
      acc[item.key] = [
        {
          required: true,
          message: `${item.labelKey}は必須です`,
          trigger: 'blur'
        }
      ];
    }
    return acc;
  }, {});

  const chips = computed(() =>
    filterSchema.value
      .filter(item => {
        const val = form[item.key];
        if (item.type === 'daterange') {
          return Array.isArray(val) && val[0] && val[1];
        }
        if (Array.isArray(val)) {
          return val.length > 0;
        }
        if (item.key === 'forcedCloseIncludeHiddenFlow') { // 「非表示フロー含む」チェックボックス
          return Number(val) === 1; // チェックボックス選択あり(1)は表示ありとしたいためtrueを渡す。それ以外は表示しない。
        }
        return val !== '' && val !== undefined && val !== null;
      })
      .map(item => {
        const val = form[item.key];
        let displayValue = '';
        if (item.type === 'daterange') {
          displayValue = `${dayjs(val[0]).format('YYYY-MM-DD')} ~ ${dayjs(val[1]).format('YYYY-MM-DD')}`;
        } else if (item.type === 'select' && Array.isArray(item.options)) {
          const isMultiple = item.multiple === true || Array.isArray(val);
          if (isMultiple && Array.isArray(val)) {
            const labels = val.map(v => {
              const opt = item.options.find(o => o.value === v);
              return opt ? opt.label : String(v);
            });
            const firstLabel = labels[0] || '';
            const trimmedLabel = firstLabel.length > 10 ? firstLabel.slice(0, 10) + '…' : firstLabel;
            const remainingCount = labels.length - 1;
            displayValue = remainingCount > 0 ? `${trimmedLabel} +${remainingCount}件` : trimmedLabel;
          } else {
            const opt = item.options.find(o => o.value === val);
            displayValue = opt ? opt.label : String(val);
          }
        } else if (Array.isArray(val)) {
          displayValue = val.length > 0 ? val[0] + (val.length > 1 ? ` +${val.length - 1}件` : '') : '';
        } else if (item.key === 'forcedCloseIncludeHiddenFlow') {
          displayValue = message('Label.Include Hidden Flow'); // 多言語化辞書で切り替え。src\utils\searchUtil.jsの【取引一覧のforcedClose補足】参照。
        } else {
          displayValue = val;
        }
        return { key: item.key, labelKey: item.labelKey, value: displayValue };
      })
  );

  const updateOptions = (key, options) => {
    const target = filterSchema.value.find(item => item.key === key);
    if (target) {
      target.options = options;
    }
  };

  const setFormValues = values => {
    Object.assign(form, values);
  };

  return { form, rules, chips, filterSchema, updateOptions, setFormValues };
}
